import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Spin,
  DatePicker,
  Row,
  Col,
  Button,
  Input,
  Icon,
  Menu,
  Dropdown,
  Modal,
  Form,
  Empty,
  Alert,
  Typography,
} from "antd";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { handleError } from "../../utils/ErrorHandlers";
import AudioPlayer from "../streaming/AudioPlayer";

import Page from "../general/Page";
import Highlighter from "react-highlight-words";
import moment from "moment";
import { convertTZToLocalCDR } from "../general/DateTzHelper";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Translation } from "react-i18next";
import i18next, { use } from "i18next";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";
import { CdrService } from "../../services/cdr/CdrService";
import { Constants } from "../../data/constants";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const cdrService = new CdrService();

function AllCdrs(props) {

    const [lang,setLang]=useState(props.context.curr_lang === "ar" &&
        props.context.curr_dir === "rtl"
          ? "ar"
          : "en");

    const [isFetching,setIsFetching]=useState(false);
    const [page,setPage]=useState(1);
    const [data,setData]=useState([]);

    const[from,setFrom]=useState( moment()
    .startOf("day")
    .format("YYYY-MM-DD HH:mm:ss")
    .toString());
    const[to,setTo]=useState(moment().format("YYYY-MM-DD HH:mm:ss").toString());

    const constants = new Constants();


    let [searchText, setSearchText] = useState("");
    let [searchedColumn, setSearchedColumn] = useState("");
  
    const searchInput = useRef(null);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
      });
    

    const handleSearch =async (selectedKeys, confirm, dataIndex) => {

      console.log(searchText)
      const currentSearchText = selectedKeys.length ==0 ? searchText : selectedKeys[0];
      setSearchText(currentSearchText);


      if(dataIndex==="a"){
       await callBackendForSearch(currentSearchText,null,null,page)
      }
      if(dataIndex==="b"){
        await callBackendForSearch(null,currentSearchText,null,page)
       }
       if(dataIndex==="c"){
        await callBackendForSearch(null,null,currentSearchText,page)
       }
        // confirm();
        // setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
      const handleReset =async (clearFilters) => {
        clearFilters();
        setSearchText("");
        await callBackend(1);

      };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={searchText}
              onChange={(e) =>{
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                setSearchText(e.target.value ? e.target.value : "");
              }

              }
              onPressEnter={async() => {
                setSelectedKeys([searchText])
                await handleSearch(selectedKeys, confirm, dataIndex)}}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Button
              type="primary"
              onClick={async() =>{ 
                setSelectedKeys([searchText])

                await handleSearch(selectedKeys, confirm, dataIndex)}}
              icon="search"
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button
              onClick={async () => await handleReset(clearFilters)}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </div>
        ),
        filterIcon: (filtered) => (
          <Icon type="search" style={{ color: "#d73a31" }} />
        ),
        onFilter: (value, record) => {
          const fieldValue = record[dataIndex];
          return (
            fieldValue &&
            fieldValue.toString().toLowerCase().includes(value.toLowerCase())
          );
        },
        onFilterDropdownVisibleChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current.select());
          }
        },
      });

    const isExpiredWithStartOfDay = (startTime) => {
    let expirationDate = moment().subtract(5, 'days');
    let startTimeMoment = moment(startTime, 'DD-MM-YYYY HH:mm:ss', true).startOf("day");
    expirationDate = expirationDate.startOf("day");
    return startTimeMoment.isSameOrBefore(expirationDate);
  };

    const columns =[ {
        title: i18next.t("A number"),
        dataIndex: "a",
        key: "a",
        ...getColumnSearchProps("a"),
        render: (text) =>
        searchedColumn === "a" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
    
      {
        title: i18next.t("B number"),
        dataIndex: "b",
        key: "b",
        ...getColumnSearchProps("b"),
        render: (text) =>
        searchedColumn === "b" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("C number"),
        dataIndex: "c",
        key: "c",
        ...getColumnSearchProps("c"),
        render: (text) =>
        searchedColumn === "c" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("Call Record"),
        dataIndex: "callRecord",
        key: "callRecord",
        render: (text, record) =>
          record.isSwitched === "true" &&
          record.callResult === "ANSWERED_BY_AGENT" ? (
            isExpiredWithStartOfDay(record.startTime) && constants.enableCallRecordExpiration
              ? <AudioPlayer record={record} type="record" disabled={true} />
              : <AudioPlayer record={record} type="record" />
          ) : (
            "---"
          ),
      },
      // {
      //   title: i18next.t("Voicemail"),
      //   dataIndex: "voicemail",
      //   key: "voicemail",
      //   render: (text, record) =>
      //     record.hasVoiceMail ? (
      //       <AudioPlayer record={record} type="voiceMail" />
      //     ) : (
      //       "---"
      //     ),
       
      // },
      {
        title: i18next.t("Start time"),
        dataIndex: "startTime",
        key: "startTime",
      },
      { title: i18next.t("End time"), dataIndex: "endTime", key: "endTime" },
      //{ title: "Is Switched", dataIndex: "isSwitched", key: "isSwitched" },
      {
        title: i18next.t("Switched Time"),
        dataIndex: "switchTime",
        key: "switchTime",
      },
      // {
      //   title: i18next.t("Call result"),
      //   dataIndex: "callResult",
      //   key: "callResult",
      //   ...getColumnSearchProps("callResult"),
      //   render: (text) =>
      //     searchedColumn === "callResult" ? (
      //       <Highlighter
      //         highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
      //         searchWords={[searchText]}
      //         autoEscape
      //         textToHighlight={text}
      //       />
      //     ) : (
      //       text
      //     ),
      // },
      {
        title: i18next.t("Call duration"),
        dataIndex: "callDuration",
        key: "callDuration",
      },
      // {
      //   title: i18next.t("Call direction"),
      //   dataIndex: "callDirection",
      //   key: "callDirection",
      //   ...getColumnSearchProps("callDirection"),
      //   render: (text) =>
      //     searchedColumn === "callDirection" ? (
      //       <Highlighter
      //         highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
      //         searchWords={[searchText]}
      //         autoEscape
      //         textToHighlight={text}
      //       />
      //     ) : (
      //       text
      //     ),
      // },
    
    ];

    useEffect(() => {
    }, []);
    
    useEffect(() => {
          if(searchText==""){
            callBackend(pagination.current);
          }else{
            if(searchedColumn=="a")
            callBackendForSearch(searchText,null,null,pagination.current);
            if(searchedColumn=="b")
              callBackendForSearch(null,searchText,null,pagination.current);
            if(searchedColumn=="c")
              callBackendForSearch(null,null,searchText,pagination.current);

          }
    }, [pagination.current,from,to]);



    const handleTableChange = (pagination) => {
        setPagination(pagination);
      };
    


    const callBackend = async(page)=>{
        setIsFetching(true);
        try{
        let data = await cdrService.getCdrsFromToStartDateByPage(
            props.context.session_id,
           from,
            to,
            page
          );
          console.log(data);
          setData(formatData(data)); 
          setPagination((prev) => ({
            ...prev,
            total: data.totalPages,
            current: page,
            pageSize: 10,
          }));
          setIsFetching(false);

        }catch (e) {
            setIsFetching(false);
            handleError(e);
          }
    }



    const callBackendForSearch = async(a,b,c,page)=>{
      setIsFetching(true);
      try{
      let data = await cdrService.searchBySpecificValuesInCdr(
          props.context.session_id,
          a,b,c,
          page,
         from,
          to,
          
        );
        console.log(data);
        setData(formatData(data)); 
        setPagination((prev) => ({
          ...prev,
          total: data.totalPages,
          current: page,
          pageSize: 10,
        }));
        setIsFetching(false);

      }catch (e) {
          setIsFetching(false);
          handleError(e);
        }
  }
    
    const formatData=(data)=> {
        const updated_data = [];
        if (data.ivrList === null) {
          return [];
        }
        console.log(data.ivrList)
    
        for (var i = 0; i < data.ivrList.length; i++) {
          var row = {};
          row["key"] = i + 1;
          row["cdrId"] = data.ivrList[i]["cdrId"];
          row["a"] = data.ivrList[i]["a"];
          row["b"] = data.ivrList[i]["b"];
          row["c"] = data.ivrList[i]["c"];

          row["startTime"] = convertTZToLocalCDR(data.ivrList[i]["startTime"]);
          row["endTime"] = convertTZToLocalCDR(data.ivrList[i]["endTime"]);
          row["switchTime"] = data.ivrList[i]["isSwitched"]
            ? convertTZToLocalCDR(data.ivrList[i]["switchTime"])
            : "---";
          row["isSwitched"] = data.ivrList[i]["isSwitched"].toString();
          row["callResult"] = data.ivrList[i]["callResult"];
          row["customerName"] = data.ivrList[i]["fullname"]
            ? data.ivrList[i]["fullname"]
            : "---";
          row["callDuration"] = new Date(
            parseFloat(data.ivrList[i]["callDuration"]).toFixed(2) * 1000
          )
            .toISOString()
            .substr(11, 8);
    
          row["callDirection"] = data.ivrList[i]["callDirection"];
          // row["hasVoiceMail"] = data.ivrList[i]["hasVoiceMail"];
          updated_data.push(row);
        }
        return updated_data;
      }

    const getAllCdrs =async ()=>{
      setIsFetching(true);
      let from = moment()
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss")
      .toString();
    let to = moment().format("YYYY-MM-DD HH:mm:ss").toString();
    setFrom(from);
    setTo(to);
    setPage(1);
    setIsFetching(false)
        }

    
    const onOk=async(dates)=>{
      setPagination({...pagination, current: 1});
        // setPage(1)
        setFrom( dates[0].format("YYYY-MM-DD HH:mm:ss").toString());
        setTo( dates[1].format("YYYY-MM-DD HH:mm:ss").toString())
   

        //  setData(formatData(data)); 
    }

    return (

        <Translation>
        {(t) => (<Page title={t("Call Detail Records")}>
<Row
 style={{
    marginTop: "30px",
    marginBottom: "8px",
    alignItems: "center",
    fontSize: "18px",
  }}>
    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <RangePicker
                  showTime={true}
                  format={"YYYY-MM-DD HH:mm:ss"}
                  onChange={(e) => {
                    if (e.length <= 0) {
                        getAllCdrs()
                    };
                  }}
                  onOk={(e) =>{
                     onOk(e)
                    }}
                  placeholder={[i18next.t("from"), i18next.t("to")]}
                  defaultValue={[
                    moment().startOf("day"),
                    moment().endOf("day"),
                  ]}
                  locale={lang === "ar" ? ar : en}
                />
                </Col>

</Row>
{isFetching ? (
              <Spin></Spin>
            ) : (<div>
                <Table
                    className="components-table-demo-nested"
                    columns={columns}
                    dataSource={data}
                    pagination={pagination}
                    loading={isFetching}
                    onChange={handleTableChange}
    


                />

            </div>)}

        </Page>)}
        </Translation>
  
    );
    
    
    }

export default withSharedStateConsumer(AllCdrs);
